export const ROUTE_INDEX = '/';
export const ROUTE_DASHBOARD = '/dashboard';
export const ROUTE_PORTAL = '/portal';
export const ROUTE_OPEN_DATA = '/portal/public-open-data';
export const ROUTE_SEARCH = '/portal/public-search';
export const ROUTE_NEWS = '/portal/public-news';
export const ROUTE_SYSTEM_INOPERABILITY = '/portal/public-system-inoperability';
export const ROUTE_FEEDBACK = '/portal/public-feedback';
export const ROUTE_OPEN_DATA_CHECK = '/portal/public-open-data/check';
export const ROUTE_OPEN_DATA_BY_YEAR = `${ROUTE_OPEN_DATA_CHECK}/:year/:month`;
export const ROUTE_KNM = '/portal/public-knm';
export const ROUTE_KNM_BY_ID = `${ROUTE_KNM}/:id`;
export const ROUTE_KNM_BY_QR_CODE = `${ROUTE_KNM}/link-only/:token`;
export const ROUTE_DECISION = '/portal/public-decision';
export const ROUTE_DECISION_BY_ID = `${ROUTE_DECISION}/:id`;
export const ROUTE_DECISION_BY_QR_CODE = `${ROUTE_DECISION}/link-only/:token`;
export const ROUTE_KNM_BY_NONEXISTENT_QR_CODE = `${ROUTE_PORTAL}/:knmNonExistentQr`;
export const ROUTE_PM_BY_NONEXISTENT_QR_CODE = `${ROUTE_PORTAL}/:pmNonExistentQr`;
export const ROUTE_PUBLIC_EXTRACT = `${ROUTE_PORTAL}/public/extract`;
